import { render } from "./MyReports.vue?vue&type=template&id=006e8287"
import script from "./MyReports.vue?vue&type=script&lang=js"
export * from "./MyReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__